// extracted by mini-css-extract-plugin
export var edge = "as-seen-on-module--edge--4e9cc";
export var icon = "as-seen-on-module--icon--a880c";
export var root = "as-seen-on-module--root--3e8e3";
export var tfk = "as-seen-on-module--tfk--f785c";
export var time = "as-seen-on-module--time--9bf73";